import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import type {
  IApiResponse,
  IAxiosFn,
  IPaginationParams,
  ISearchParams,
  IWithFilters,
  IWithPagination,
  IWithStats,
} from "@/api";
import { axiosClient } from "@/api";
import type { AxiosError } from "@api/types.ts";
import { getApi } from "@api/apiPath";
import type { IAppointmentTableEndpoint } from "@api/appointment";

const { key, getPath } = getApi("msp.appointments.getAll");

type IResponse = AxiosResponse<
  IApiResponse<
    IWithFilters<IWithStats<IWithPagination<IAppointmentTableEndpoint>>>
  >
>;
type IVariables = { attended?: 0 | 1 } & IPaginationParams & ISearchParams;

export const getAllMedicalServiceAppointments: IAxiosFn<
  IVariables,
  IResponse
> = async (params, signal) => {
  return axiosClient.get(getPath(), {
    params,
    signal,
  });
};

export const useGetAllMedicalServiceAppointments = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getAllMedicalServiceAppointments(variables, signal),
});
